import { createSelector } from 'reselect'

const getEntities = ({ entity }) => entity.records
const getFetchingEntities = ({ entity }) => entity.fetchingEntities

const glCodeSelectors = {
  getFetchingEntities: createSelector(
    [getFetchingEntities],
    (fetchingEntities) => fetchingEntities,
  ),

  getEntities: createSelector([getEntities], (entities) => entities),
}

export default glCodeSelectors
